export default __webpack_public_path__ + "static/media/resume.9d1c92ca.pdf";